import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  AlertController,
  LoadingController,
  ToastController,
} from '@ionic/angular';
import { Subscription } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { Share } from '@capacitor/share';
import { MessagingService } from '../shared/services/messaging.service';
@Component({
  selector: 'app-account',
  templateUrl: './account.page.html',
  styleUrls: ['./account.page.scss'],
})
export class AccountPage implements OnInit {
  isAdmin = false;
  constructor(
    private authService: AuthService,
    private messagingService: MessagingService,
    private alertCtrl: AlertController
  ) { }

  async ngOnInit() {
    this.isAdmin = await this.authService.isAdmin();
  }
  async shareApp() {
    const url = 'https://play.google.com/store/apps/details?id=com.mimbo.app';
    await Share.share({
      title: 'Check this out',
      text: `Discover this amazing app made just for you and your furry friend! ${url}`,
    });
  }
  async logout() {
    const userId = await this.authService.getUserId();
    this.messagingService.unregisterToken(userId);
    this.authService.logout();
  }

  confirmLogout() {
    this.alertCtrl
      .create({
        header: 'Log Out',
        message: 'Are you sure you want to logout?',
        buttons: [
          {
            text: 'Cancel',
            handler: () => {
              this.alertCtrl.dismiss();
            },
          },
          {
            text: 'Log Out',
            cssClass: 'confirm-delete',
            handler: () => {
              this.logout();
              this.alertCtrl.dismiss();
            },
          },
        ],
      })
      .then((alertEl) => alertEl.present());
  }
}
